/* Deutsche Übersetzungen */
const de = {
  lang: 'de',
  langLabel: 'Deutsch',
  login: {
    welcome: 'Willkommen zurück',
    subtitle: 'Melden Sie sich bei Ihrem Atunears-Panel an.',
    email: 'E-Mail',
    emailPlaceholder: 'beispiel@atunears.com',
    password: 'Passwort',
    passwordPlaceholder: '••••••••',
    showPassword: 'Passwort anzeigen',
    hidePassword: 'Passwort verbergen',
    rememberMe: 'Angemeldet bleiben',
    forgotPassword: 'Passwort vergessen',
    submit: 'Anmelden',
    submitting: 'Anmeldung läuft…',
    noAccount: 'Kein Konto?',
    contactUs: 'Bitte kontaktieren Sie uns.',
    tagline: 'Personalisiertes Klangerlebnis',
    heroTitle: '<em>Frequenzen </em>für Ihre Ohren.<br/><em>Maßgeschneiderte</em> Kopfhörer.',
    heroDesc: 'Verwalten Sie Ihre persönliche Klangsignatur, Bestellverfolgung und Ohrabdruck-Termine – alles an einem Ort.',
    feature1: 'Persönlicher Ohrabdruck & Klangsignatur',
    feature2: 'Handgefertigte, individuelle Gehäuse',
    feature3: 'Bestell- und Terminpanel',
  },
  topbar: {
    adminPanel: 'Admin-Panel',
    adminPanelSub: 'Verwalten Sie Benutzer, Formulare und Zuweisungen in Ihrem Kundenkonto.',
    userPanel: 'Benutzer-Panel',
    userPanelSub: 'Füllen Sie Ihre zugewiesenen Formulare aus und verfolgen Sie Ihre Einreichungen.',
    refresh: 'Aktualisieren',
    lightMode: 'Zum hellen Modus wechseln',
    darkMode: 'Zum dunklen Modus wechseln',
  },
  sidebarUser: {
    myForms: 'Meine Formulare',
    newForm: 'Neues Formular',
    sentForms: 'Meine Einreichungen',
  },
  sidebarAdmin: {
    formManagement: 'Formularverwaltung',
    addForm: 'Formular hinzufügen',
    listForms: 'Formulare auflisten',
    moldTypes: 'Otoplastikverwaltung',
    users: 'Benutzer',
    userManagement: 'Benutzerverwaltung',
    data: 'Daten',
    submissions: 'Einreichungen',
    kanban: 'Kanban',
  },
  userForms: {
    noMoldTitle: 'Noch keine Otoplastiktypen definiert',
    noMoldDesc: 'Sobald Ihr Administrator Otoplastiktypen definiert, erscheinen sie hier automatisch. Wenden Sie sich bei Fragen an Ihren Administrator.',
    secureConnection: 'Sichere Verbindung',
    chooseMoldLabel: 'Otoplastikauswahl',
    chooseMoldTitle: 'Wählen Sie den Otoplastiktyp aus, den Sie ausfüllen möchten',
    chooseMoldSub: (n) => `Sie können aus ${n} verschiedenen Otoplastiktypen wählen. Wählen Sie unten einen aus, um fortzufahren.`,
    selectedMoldLabel: 'Ausgewählter Otoplastiktyp',
    moldList: 'Otoplastikliste',
    loadingForm: 'Formular wird geladen…',
    footerSecure: 'Ihre Daten werden über eine verschlüsselte Verbindung übertragen.',
    footerPlatform: 'Atunears Formularplattform',
  },
  userSubmissions: {
    title: 'Meine Einreichungen',
    subtitle: 'Filtern Sie Ihre Einreichungen nach Formularname, Status oder Datumsbereich.',
    formNameLabel: 'Formularname',
    formNamePlaceholder: 'Formular suchen',
    statusLabel: 'Status',
    all: 'Alle',
    dateFrom: 'Von',
    dateTo: 'Bis',
    records: (n) => `${n} Eintrag${n !== 1 ? 'e' : ''}`,
    noResults: 'Keine Einreichungen entsprechen den aktuellen Filtern.',
    colForm: 'Formular',
    colStatus: 'Status',
    colDate: 'Eingereicht',
    inspect: 'Ansehen',
    submittedAt: 'Einreichungsdatum',
    downloadPdf: 'PDF herunterladen',
    filesTitle: (n) => `Angehängte Dateien (${n})`,
    clearAllFiles: 'Alle löschen',
    clearing: 'Wird gelöscht…',
  },
  submissions: {
    title: 'Einreichungen',
    subtitle: 'Filtern und in der Tabelle ansehen. Verwenden Sie den Kanban-Bildschirm, um den Status zu ändern.',
    records: (shown, total) => `${shown} / ${total} Einträge`,
    filtersLabel: 'Filter',
    clearFilters: 'Zurücksetzen',
    searchPlaceholder: 'Nach Formular, Benutzer oder Status suchen…',
    searchLabel: 'Suche',
    dateFrom: 'Von',
    dateTo: 'Bis',
    formsGroup: 'Formulare',
    usersGroup: 'Benutzer',
    statusesGroup: 'Status',
    colForm: 'Formular',
    colUser: 'Benutzer',
    colStatus: 'Status',
    colSubmitted: 'Eingereicht',
    colUpdated: 'Aktualisiert',
    colActions: 'Aktionen',
    noResults: 'Keine Einreichungen entsprechen den aktuellen Filtern.',
    download: 'Herunterladen',
    downloadPdf: 'PDF herunterladen',
    clearFiles: 'Löschen',
    inspect: 'Ansehen',
    noFiles: 'Diese Einreichung enthält keine herunterladbaren Dateien.',
    confirmClear: 'Alle Dateien dieser Einreichung werden dauerhaft aus S3 gelöscht. Fortfahren?',
    kanbanEmpty: 'Hierher ziehen',
    noStatuses: 'Noch kein Status definiert.',
    statusLabel: 'Status',
    filesTitle: (n) => `Angehängte Dateien (${n})`,
    clearAllFiles: 'Alle löschen',
    clearing: 'Wird gelöscht…',
    selectPlaceholder: 'Formular auswählen',
    userSelectPlaceholder: 'Benutzer auswählen',
    noFormOptions: 'Keine Formulare gefunden',
    noUserOptions: 'Keine Benutzer gefunden',
    searchInDropdown: 'Suchen…',
    noDropdownResults: 'Keine Ergebnisse',
    selectedCount: (n) => `${n} ausgewählt`,
    clearSelection: 'Auswahl aufheben',
    completedToggleGroup: 'Abgeschlossen',
    showCompleted: 'Abgeschlossene anzeigen',
    kanbanTitle: 'Bestell-Kanban',
    kanbanSubtitle: 'Bestellungen per Drag & Drop zwischen Status verschieben. Abgeschlossene Bestellungen sind standardmäßig ausgeblendet.',
  },
  moldTypes: {
    title: 'Otoplastikverwaltung',
    subtitle: 'Laden Sie die Otoplastiktypen hoch, die Benutzer vor dem Ausfüllen eines Formulars auswählen, und verknüpfen Sie deren Formulare nach Sprache.',
    newMold: 'Neuer Otoplastiktyp',
    newMoldDefaultName: 'Neuer Otoplastiktyp',
    noMolds: 'Noch keine Otoplastiktypen definiert. Beginnen Sie mit "Neuer Otoplastiktyp".',
    selectMoldHint: 'Wählen Sie links einen Otoplastiktyp zum Bearbeiten aus.',
    uploadImage: 'Bild hochladen',
    uploading: 'Wird hochgeladen…',
    uploadError: 'Beim Hochladen des Bildes ist ein Fehler aufgetreten.',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    deleteMold: 'Löschen',
    confirmDelete: (name) => `Soll "${name}" gelöscht werden? Verknüpfte Formulare werden nicht gelöscht, nur die Verknüpfung wird entfernt.`,
    moldNameTitle: 'Name nach Sprache',
    moldNameHint: 'Benutzer sehen den Otoplastiktyp mit dem Namen in ihrer eigenen Sprache. Türkisch ist erforderlich; Englisch und Deutsch sind optional.',
    moldNamePlaceholderRequired: 'z. B. Vollkoncha',
    moldNamePlaceholderOptional: 'Ohne Eingabe wird der türkische Name verwendet',
    required: 'erforderlich',
    languageFormsTitle: 'Formulare nach Sprache',
    languageFormsHint: 'Wählen Sie für jede Sprache ein eigenes Formular. Türkisch wird empfohlen; Englisch und Deutsch sind optional.',
    recommended: 'empfohlen',
    pickForm: 'Formular auswählen',
    removeLink: 'Verknüpfung entfernen',
  },
  common: {
    loading: 'Wird geladen…',
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    close: 'Schließen',
    yes: 'Ja',
    no: 'Nein',
  },
  sidebar: {
    logout: 'Abmelden',
    collapse: 'Einklappen',
    expand: 'Ausklappen',
    openMenu: 'Menü öffnen',
    closeMenu: 'Menü schließen',
  },
  statuses: {
    Forwarded: 'Weitergeleitet',
    InProduction: 'In Produktion',
    Shipped: 'Versandt',
  },
};

export default de;
